var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNavButtonRightArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 45,
  viewBox: "0 0 13 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 -3L12 22.5L0 48",
  stroke: "#DDDDDD"
})));
export default SvgNavButtonRightArrow;